import axiosInstance from '../helpers/axiosInstance';

export const getPoProjectDetailApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}/projectsProductDetail`);
    return response.data;
};

export const getVerticesDropdownApi = async () => {
    const response = await axiosInstance.get('public/vertex');
    return response.data;
};

export const getBoqProjectDropdownApi = async () => {
    const response = await axiosInstance.get('staff/boqProjects');
    return response.data;
};

export const createPoProjectApi = async (request) => {
    const response = await axiosInstance.post('staff/purchaseOrderProject', request.formData);
    return response.data;
};

export const updatePoProjectApi = async (request) => {
    const response = await axiosInstance.put('staff/purchaseOrderProject', request.formData);
    return response.data;
};

export const deletePoProjectApi = async (id) => {
    const response = await axiosInstance.delete(`staff/purchaseOrderProject/${id}`);
    return response.data;
};

export const updatePoProductApi = async (request) => {
    const response = await axiosInstance.put('staff/purchaseOrderProject/projectProducts', request.formData);
    return response.data;
};

export const deletePoProductApi = async (id) => {
    const response = await axiosInstance.delete(`staff/purchaseOrderProject/projectProducts/${id}`);
    return response.data;
};

export const deletePoApi = async (id) => {
    const response = await axiosInstance.delete(`staff/purchasedOrder/${id}`);
    return response.data;
};

export const createPoProductApi = async (request) => {
    const response = await axiosInstance.post('staff/purchaseOrderProject/products', request.formData);
    return response.data;
};

export const updatePoIgnoreFieldsApi = async (request) => {
    const response = await axiosInstance.put('staff/purchaseOrder/ignoredFields', request.formData);
    return response.data;
};

export const getPoFooterApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}/footer`);
    return response.data;
};

export const createPoFooterApi = async () => {
    const response = await axiosInstance.get('staff/purchaseOrder/footer');
    return response.data;
};

export const updatePoFooterApi = async (request) => {
    const response = await axiosInstance.put('staff/purchaseOrder/footer', request.formData);
    return response.data;
};

export const deletePoFooterApi = async (id) => {
    const response = await axiosInstance.delete(`staff/purchaseOrder/footer/${id}`);
    return response.data;
};

export const previewPoApi = async (id) => {
    const response = await axiosInstance.get(`public/purchaseOrder/${id}/html`, { responseType: 'text' });
    return response.data;
};

export const generatePoApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}/generate`);
    return response.data;
};

export const sendPoApi = async (id) => {
    const response = await axiosInstance.put(`staff/purchaseOrder/${id}/markSent`);
    return response.data;
};

export const clonePoApi = async (id) => {
    const response = await axiosInstance.post(`staff/purchaseOrder/${id}/clone`);
    return response.data;
};

export const revisePoApi = async (id) => {
    const response = await axiosInstance.post(`staff/purchaseOrder/${id}/clone?revised=true`);
    return response.data;
};

export const cancelPoApi = async (id) => {
    const response = await axiosInstance.put(`staff/purchaseOrder/${id}/cancel`);
    return response.data;
};

export const verifyPoApi = async (request) => {
    const response = await axiosInstance.post('staff/purchaseOrder/verifyV1', request.formData);
    return response.data;
};

export const getConfirmProductsApi = async () => {
    const response = await axiosInstance.get('staff/billOfQuantity/listOfBoqForConvertToPo');
    return response.data;
};

export const getPoByIdApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}`);
    return response.data;
};

export const getPoVerifiedProductsApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${id}/verifiedProductList`);
    return response.data;
};

export const getPoInwardListApi = async () => {
    const response = await axiosInstance.get('staff/inward/verifiedListForInward');
    return response.data;
};

export const addPoInwardApi = async (request) => {
    const response = await axiosInstance.post('staff/products/stock', request.formData);
    return response.data;
};

export const addPoInwardProductsApi = async (request) => {
    const response = await axiosInstance.post('staff/products/inward', request.formData);
    return response.data;
};

export const getPoConvertProductsApi = async (request) => {
    const response = await axiosInstance.post('staff/billOfQuantity/listOfBoqProductsForConvertToPo', request.formData);
    return response.data;
};

export const editPoCustomProductApi = async (request) => {
    const response = await axiosInstance.put('staff/purchaseOrderProject/editCustomProduct', request.formData);
    return response.data;
};

export const convertToPoApi = async (request) => {
    const response = await axiosInstance.post('staff/purchaseOrder/convertBoqToPo', request.formData);
    return response.data;
};

export const getPoMailDetailsApi = async (id) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/sendMail/${id}`);
    return response.data;
};

export const sendPoMailApi = async (request) => {
    const response = await axiosInstance.post('staff/purchaseOrder/sendMail', request.formData);
    return response.data;
};

export const getVendorPoCsv = async (request) => {
    const response = await axiosInstance.get(`staff/purchaseOrder/${request.id}/csv`, { responseType: 'text' });
    return response.data;
};
